import React, { useState } from 'react';
import PageHeading from '../../layout/PageHeading';
import { Box, CircularProgress } from '@mui/material';
import ShopCard from './components/ShopCard'
import CarouselComponent from '../About/components/CarouselComponent';

const Shop = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <>
      {!isLoaded && (
        <Box sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100vh',
          backgroundColor: '#000000cc',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 9999,
        }}>
          <CircularProgress size={60} thickness={4.5} sx={{ color: '#BB9D7B' }} />
        </Box>
      )}

      <PageHeading title={'Shop'} />
      <ShopCard onLoaded={() => setIsLoaded(true)}/>
      <CarouselComponent/> 
    </>
  );
};

export default Shop;
